import axios from 'axios'
import { alert } from "devextreme/ui/dialog" 
const baseUri = "WebApi.asmx/api/NotificationEventListService";
const store = {};
const mutations = {
    GET_LIST_SIMPLE(state, posts) {
        state.notificationSimpleList = posts.data;
    }, 
    GET_PARSED_NOTIFICATION(state, posts) {
        state.parsedNotification = posts.data;
    }, 
};
const state = {
    notificationSimpleList: [],
    parsedNotification: [],
};
const getters = {};
const actions = {
    getNotificationSimpleList({ commit }) {
        axios
            .get(baseUri + '/GetListSimple')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_LIST_SIMPLE', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getParsedNotification({ commit }, { topicId, nevId }) {
       return axios
            .get(baseUri + '/GetParsedNotification', { params: { topicId: topicId, nevId: nevId } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_PARSED_NOTIFICATION', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res.data;
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}